import { Form } from 'antd'
import { useEffect, useState } from 'react'
import { FloatFooter } from '../../../../../components/FloatFooter/FloatFooter'
import { BTN_TXT } from '../../../../../constants'
import { Forms } from '../../../../../components/Forms'
import { TCommunityDetailsForm } from 'components/Forms/forms.communityDetails.d'

export const EditCommunityDetails = ({
  communityData
}: {
  communityData: TCommunityDetailsForm
}) => {
  const [form] = Form.useForm<TCommunityDetailsForm>()
  const [isActive, setIsActive] = useState(false)

  const resetFormChanges = () => {
    form.setFieldsValue(communityData)
    setIsActive(false)
  }

  useEffect(() => {
    form.setFieldsValue(communityData)
  }, [communityData, form])

  return (
    <div>
      <div>
        <Forms.CommunityDetails form={form} setIsActive={setIsActive} />
      </div>
      <FloatFooter
        isActive={isActive}
        onCancel={resetFormChanges}
        onSave={form.submit}
        saveBtnText={BTN_TXT.SAVE}
      />
    </div>
  )
}
